
export default {
  name: 'ModalTop',

  props: {
    title: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    isSuccess: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
    canQuit: { type: Boolean, default: true },
    icon: { type: String, default: 'checkmark' },
  },

  computed: {
    checkmarkColor() {
      return this.isSuccess ? '#00D16A' : this.isError ? '#D92D20' : 'currentColor'
    },
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
